import * as yup from 'yup';
export const scheduleCallSchema = yup.object().shape({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  phoneNumber: yup.string().required('Phone number is required'),
  targetCountry: yup.string().required('Target country is required'),
  purpose: yup.string().required('Project type is required'),
  comment: yup.string(),
})